import { useState } from "react";

interface TooltipProps {
  text: any;
  isVisible: boolean;
  children: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ text, isVisible, children }) => {
  const [isHovered, setIsHovered] = useState(false);

  const show = isVisible && isHovered;

  return (
    <div
      className="relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      {show && (
        <div className="absolute shadow-base -ml-[50%] my-2 z-50 break-words py-1.5 px-3 focus:outline-none text-center bg-white text-gray_3 p-2 rounded-md z-10 min-w-[275px]">{text}</div>
      )}
    </div>
  );
};

export default Tooltip;
